import { displayDefaultDateTime } from 'app/shared/util/date-utils';
import { displayPercent } from 'app/shared/util/percent';
import * as _ from 'lodash';

export const columnsQual = [
  {
    title: 'Ngày cập nhật',
    sorter: true,
    key: 'reportDate',
    width: 120,
    dataIndex: 'reportDate',
    render: item => displayDefaultDateTime(item),
  },
  {
    title: 'Kỳ kế hoạch',
    key: 'planPeriodName',
    width: 120,
    dataIndex: 'planPeriodName',
  },
  {
    title: 'Kỳ báo cáo',
    key: 'reportScheduleName',
    width: 120,
    dataIndex: 'reportScheduleName',
  },
  {
    title: 'KQ cần đạt được',
    key: 'target',
    width: 250,
    dataIndex: 'target',
  },
  {
    title: 'Thời hạn hoàn thành',
    sorter: true,
    width: 120,
    key: 'dueDate',
    dataIndex: 'dueDate',
    render: item => displayDefaultDateTime(item),
  },
  {
    title: 'Tình trạng',
    key: 'workStatus',
    width: 100,
    dataIndex: 'workStatus',
  },
  {
    title: 'Ngày hoàn thành',
    sorter: true,
    width: 120,
    key: 'completedOn',
    dataIndex: 'completedOn',
    render: item => displayDefaultDateTime(item),
  },
  {
    title: 'Đã hoàn thành',
    key: 'completeNote',
    width: 250,
    dataIndex: 'completeNote',
  },
  {
    title: 'Lý do không hoàn thành, Tạm dừng, Hủy',
    key: 'unfinishNote',
    width: 250,
    dataIndex: 'unfinishNote',
  },
  {
    title: 'Đánh giá',
    key: 'finishPercentage',
    width: 100,
    dataIndex: 'finishPercentage',
    render: item => _.isInteger(item) ? displayPercent(item) : displayPercent(_.round(item, 2))
  },
  {
    title: 'Khó khăn & nguyên nhân',
    key: 'issue',
    width: 250,
    dataIndex: 'issue',
  },
  {
    title: 'Giải pháp & kiến nghị',
    key: 'solution',
    width: 250,
    dataIndex: 'solution',
  },
  {
    title: 'PIC',
    width: 120,
    key: 'accountableName',
    dataIndex: 'accountableName',
  },
];

export const columnsQuanti = [
  {
    title: 'Ngày cập nhật',
    sorter: true,
    key: 'reportDate',
    width: 120,
    dataIndex: 'reportDate',
    render: item => displayDefaultDateTime(item),
  },
  {
    title: 'Kỳ kế hoạch',
    key: 'planPeriodName',
    width: 100,
    dataIndex: 'planPeriodName',
  },
  {
    title: 'Kỳ báo cáo',
    key: 'reportScheduleName',
    width: 100,
    dataIndex: 'reportScheduleName',
  },
  {
    title: 'KQ cần đạt được',
    key: 'target',
    width: 250,
    dataIndex: 'target',
  },
  {
    title: 'Đã hoàn thành',
    key: 'completeNote',
    width: 250,
    dataIndex: 'completeNote',
  },
  {
    title: 'Đánh giá',
    key: 'finishPercentage',
    width: 100,
    dataIndex: 'finishPercentage',
    render: item => _.isInteger(item) ? displayPercent(item) : displayPercent(_.round(item, 2))
  },
  {
    title: 'Tình trạng',
    key: 'workStatus',
    width: 100,
    dataIndex: 'workStatus',
  },
  {
    title: 'Lý do không hoàn thành, Tạm dừng, Hủy',
    key: 'unfinishNote',
    width: 250,
    dataIndex: 'unfinishNote',
  },
  {
    title: 'Khó khăn & nguyên nhân',
    key: 'issue',
    width: 250,
    dataIndex: 'issue',
  },
  {
    title: 'Giải pháp & kiến nghị',
    key: 'solution',
    width: 250,
    dataIndex: 'solution',
  },
  {
    title: 'PIC',
    width: 120,
    key: 'accountableName',
    dataIndex: 'accountableName',
  },
];
